webpackJsonp([14],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(40);
var getKeys = __webpack_require__(101);
var toIObject = __webpack_require__(100);
var isEnum = __webpack_require__(235).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1446), __esModule: true };

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1447);
module.exports = __webpack_require__(12).Object.values;


/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(28);
var $values = __webpack_require__(1441)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 1506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return companyFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return companyAccountFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return finCenterConfigRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return departmentJobFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return invoiceNameAddRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return invoiceNameEditRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baiWangCfgForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的财务中心设置ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  payment_apply_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择付款类型', 'integer'))],
  first_subject_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择一级科目', 'integer'))]
};

var companyFormRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入公司名称'))],
  finance_ids: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择财务负责人', 'array'))],
  kingdee_number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入金蝶编码'))]
};

var companyAccountFormRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入账户名称'))],
  our_company_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择公司', 'integer'))],
  number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入银行卡号'))],
  bank_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择开户银行', 'integer'))]
};

var finCenterConfigRules = {
  approve_amount_lv1: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入一级审批起始值', 'integer', 'blur', true), { min: 0 })],
  approve_amount_lv2: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入二级审批起始值', 'integer', 'blur', true), { min: 0 })],
  approve_amount_lv3: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入三级审批起始值', 'integer', 'blur', true), { min: 0 })],
  approve_amount_lv4: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入四级审批起始值', 'integer', 'blur', true), { min: 0 })]
};

var departmentJobFormRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入部门岗位名称'))]
};

var invoiceNameAddRule = {
  tax_rate: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入税率，范围 0-100', 'integer'))],
  product_num: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入商品编码', 'string'))],
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入开票名称', 'string'))],
  type_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择开票名称类别', 'integer'))]
};

var invoiceNameEditRule = {
  tax_rate: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入税率，范围 0-100', 'integer'))],
  product_num: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入商品编码', 'string'))]
};

var baiWangCfgForm = {
  tax_panel_pwd: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('税控盘口令 不能为空', 'string'))],
  digital_cert_pwd: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('数字证书密码 不能为空', 'string'))],
  bw_register_code: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('百旺注册码 不能为空', 'string'))],
  address_and_phone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('销货地址单位及电话 不能为空', 'string'))],
  bank_acct: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('销货单位银行帐号 不能为空', 'string'))],
  code_version_number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('百旺编码版本号 不能为空', 'string'))],
  ticket_payee: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('收款人 不能为空', 'string'))],
  ticket_reviewer: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('复核人 不能为空', 'string'))]
};

/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function () {
  return new Worker(__webpack_require__.p + "2f6ec96fc704f66aecaa.worker.js");
};

/***/ }),

/***/ 2669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_InvoiceNameBatchExcel__ = __webpack_require__(3959);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { InvoiceNameBatchExcel: __WEBPACK_IMPORTED_MODULE_4__components_InvoiceNameBatchExcel__["a" /* default */] },
  data: function data() {
    return {
      form: {
        data: []
      },
      error_data: [],
      percentage: 0,
      file: null,
      fileHeader: []
    };
  },

  computed: {},
  watch: {},
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, request.map([]), {
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.$refs['form'].$refs['InvoiceNameBatchExcel'].clearFiles();
    },
    getFormData: function getFormData() {
      return _.cloneDeep(this.form.data);
    },
    onSubmit: function onSubmit() {
      if (this.form.data.length === 0) {
        this.$message.error('请选择文件');
      } else {
        this.createOrUpdate();
      }
    },
    excelFileRemove: function excelFileRemove(fileList) {
      if (fileList.length === 0) {
        this.form.data = [];
      }
    },
    createOrUpdate: function createOrUpdate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, index, param, num, info;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _this.getFormData();

                _this.error_data = [];
                index = 0;

              case 3:
                if (!(index < data.length)) {
                  _context.next = 30;
                  break;
                }

                param = data[index];
                num = index + 1;

                _this.percentage = num / data.length * 100;

                info = '第' + num + '行 ';

                if (!_this.checkParams(param, info)) {
                  _context.next = 27;
                  break;
                }

                _context.prev = 9;

                if (!(_this.$route.meta.type === 'batch_edit')) {
                  _context.next = 15;
                  break;
                }

                _context.next = 13;
                return request.loading('editInvoiceName', param);

              case 13:
                _context.next = 22;
                break;

              case 15:
                if (!(_this.$route.meta.type === 'batch_create')) {
                  _context.next = 20;
                  break;
                }

                _context.next = 18;
                return request.loading('batchCreateInvoiceName', param);

              case 18:
                _context.next = 22;
                break;

              case 20:
                _this.error_data.push('路由错误');
                return _context.abrupt('return', false);

              case 22:
                _context.next = 27;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context['catch'](9);

                _this.error_data.push(info + _context.t0.message);

              case 27:
                index++;
                _context.next = 3;
                break;

              case 30:
                if (_this.error_data.length === 0) {
                  _this.$confirm('上传成功，是否返回列表查看', '提示', { type: 'warning' }).then(function () {
                    _this.$router.back();
                  });
                }

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 24]]);
      }))();
    },
    checkParams: function checkParams(param, info) {
      var err = '';
      var reqHeader = this.xlsxReqHeader();
      for (var ruleKey in reqHeader) {
        if (param[ruleKey] === '') {
          err = reqHeader[ruleKey].text + ' 为空';
          break;
        }
      }

      // 转换请求参数数值
      this.convertParamValue(param, info, err);

      if (err) {
        this.error_data.push(info + err);
        return false;
      }
      return true;
    },
    convertParamValue: function convertParamValue(param, info, err) {
      if (param.hasOwnProperty('tax_rate')) {
        param.tax_rate = param.tax_rate.toString().replace('%', '');
        if (param.tax_rate < 1) {
          param.tax_rate *= 100;
        }
      }
      if (param.hasOwnProperty('is_disabled')) {
        if (param.is_disabled === '启用中') {
          param.is_disabled = 0;
        } else if (param.is_disabled === '已禁用') {
          param.is_disabled = 1;
        } else {
          err = '禁用状态仅支持输入【启用中】、【已禁用】';
        }
      }
    },

    // 返回 excel 文件必须存在的表头字段
    xlsxReqHeader: function xlsxReqHeader() {
      if (this.$route.meta.type === 'batch_edit') {
        return {
          id: { index: null, text: '开票名称ID' },
          tax_rate: { index: null, text: '税率' },
          product_num: { index: null, text: '商品编码' },
          is_disabled: { index: null, text: '禁用状态' }
        };
      } else if (this.$route.meta.type === 'batch_create') {
        return {
          name: { index: null, text: '开票名称' },
          type_name: { index: null, text: '开票名称类别' },
          tax_rate: { index: null, text: '税率' },
          product_num: { index: null, text: '商品编码' }
        };
      }
      this.error_data = ['路由错误'];
      return {};
    },
    getDemo: function getDemo() {
      if (this.$route.meta.type === 'batch_edit') {
        this.getUpdateDemo();
      } else if (this.$route.meta.type === 'batch_create') {
        this.getCreateDemo();
      } else {
        this.error_data = ['路由错误，无法下载 demo 文件'];
      }
    },
    getCreateDemo: function getCreateDemo() {
      var demo = [{ 'name': '其他服务费', type_name: '其他', tax_rate: '6%', product_num: '3049900000000000000' }, { 'name': '其他咨询服务费', type_name: '其他', tax_rate: '6%', product_num: '3049900000000000001' }];
      this.$export('批量添加开票名称 Demo', demo, { fileHeader: this.getDemoHeader(this.xlsxReqHeader()) });
    },
    getUpdateDemo: function getUpdateDemo() {
      var demo = [{ id: 1, tax_rate: '6%', product_num: '3049900000000000000', is_disabled: '启用中' }, { id: 2, tax_rate: '6%', product_num: '3049900000000000001', is_disabled: '启用中' }];
      this.$export('批量更新开票名称 Demo', demo, { fileHeader: this.getDemoHeader(this.xlsxReqHeader()) });
    },
    getDemoHeader: function getDemoHeader(reqHeader) {
      var demoHeader = [];
      for (var key in reqHeader) {
        if (reqHeader.hasOwnProperty(key) && reqHeader[key].hasOwnProperty('text')) {
          demoHeader.push({ key: key, text: reqHeader[key].text });
        }
      }
      return demoHeader;
    }
  })
});

/***/ }),

/***/ 2670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var worker = new __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker___default.a();
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    xlsxReqHeader: Object
  },
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    xlsxReqText: function xlsxReqText() {
      var text = [];
      var xlsxHead = _.cloneDeep(this.xlsxReqHeader);
      for (var key in xlsxHead) {
        if (xlsxHead.hasOwnProperty(key) && xlsxHead[key].hasOwnProperty('text')) {
          text.push(this.xlsxReqHeader[key].text);
        }
      }
      return text ? '【' + text.join('、') + '】' : '--';
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getDemo: function getDemo() {
      this.$emit('getDemo');
    },
    excelFileChange: function excelFileChange(file, fileList) {
      if (file.status === 'ready') {
        // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
        if (fileList.length >= 2) {
          fileList.shift();
        }
      }
    },
    excelFileRemove: function excelFileRemove(file, fileList) {
      this.$emit('excelFileRemove', fileList);
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!');
      }
      return isLt2M;
    },
    uploadRequest: function uploadRequest(obj) {
      var _this = this;

      this.loading = true;
      this.$emit('change-file', obj.file);
      worker.postMessage({ file: obj.file, options: { header: 1 } });
      worker.onmessage = function (event) {
        // 处理数据
        _this.handleExcelData(event.data);
        _this.loading = false;
      };
    },
    handleExcelData: function handleExcelData(rows) {
      var _this2 = this;

      var items = [];
      var tableHeader = this.xlsxReqHeader;
      try {
        rows.forEach(function (row, rowIndex) {
          var item = {};
          row.forEach(function (cell, cellIndex) {
            if (rowIndex) {
              // 获得数据行前 检查表头是否存在
              if (rowIndex === 1) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tableHeader)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var header = _step.value;

                    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(header.index)) {
                      _this2.loading = false;
                      _this2.$refs.InvoiceNameBatchExcel.clearFiles();
                      throw new Error('\u627E\u4E0D\u5230 [' + header.text + '] \u8868\u5934');
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }
              // 表格的行数据获取
              for (var field in tableHeader) {
                if (tableHeader.hasOwnProperty(field)) {
                  // 根据字段的 index 获得相应的值
                  if (cellIndex === tableHeader[field].index) {
                    item[field] = cell;
                  }
                }
              }
            } else {
              // 检查表头字段是否存在
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tableHeader)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _header = _step2.value;

                  if (cell === _header.text) {
                    _header.index = cellIndex;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          });
          rowIndex && items.push(item);
        });
        this.$emit('change', items);
      } catch (e) {
        this.$alert(e.toString(), '提示', { type: 'error' });
        throw new Error(e);
      }
    }
  }
});

/***/ }),

/***/ 2671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__finance_config_rules_js__ = __webpack_require__(1506);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      id: 0,
      invoiceNameAddRule: __WEBPACK_IMPORTED_MODULE_2__finance_config_rules_js__["g" /* invoiceNameAddRule */],
      invoiceNameEditRule: __WEBPACK_IMPORTED_MODULE_2__finance_config_rules_js__["h" /* invoiceNameEditRule */],
      form: {
        name: '',
        type_id: null,
        type_name: '',
        tax_rate: null,
        product_num: null,
        full_name: null
      }
    };
  },

  computed: {},
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['invoiceNameTypeLists', 'getInvoiceNameType']), {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.common('getInvoiceName', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);
      });
    },
    getForm: function getForm() {
      return filter.copyJson(this.form);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.id ? _this2.update(_this2.id) : _this2.create();
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this3 = this;

      request.common('createInvoiceName', this.getForm()).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this3.$refs.form.resetFields();
        }, function () {
          _this3.$router.push({ path: '/finance-config/invoice-name-management' });
        });
      });
    },
    update: function update(id) {
      var _this4 = this;

      request.common('editInvoiceName', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this4.$router.push({ path: '/finance-config/invoice-name-management' });
        });
      });
    }
  })
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanceInvoiceNameBatchForm_vue__ = __webpack_require__(2669);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217aee9c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanceInvoiceNameBatchForm_vue__ = __webpack_require__(3967);
function injectStyle (ssrContext) {
  __webpack_require__(3953)
  __webpack_require__(3955)
  this["$style"] = __webpack_require__(3957)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-217aee9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanceInvoiceNameBatchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217aee9c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanceInvoiceNameBatchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanceInvoiceNameForm_vue__ = __webpack_require__(2671);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ee3030_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanceInvoiceNameForm_vue__ = __webpack_require__(3974);
function injectStyle (ssrContext) {
  __webpack_require__(3968)
  __webpack_require__(3970)
  this["$style"] = __webpack_require__(3972)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09ee3030"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanceInvoiceNameForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ee3030_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanceInvoiceNameForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3953:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3954);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("50161564", content, true, {});

/***/ }),

/***/ 3954:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FinanceInvoiceNameBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3955:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3956);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("61ef125a", content, true, {});

/***/ }),

/***/ 3956:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FinanceInvoiceNameBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3957:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3958);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("48fa82c0", content, true, {});

/***/ }),

/***/ 3958:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FinanceInvoiceNameBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceNameBatchExcel_vue__ = __webpack_require__(2670);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_344d770e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceNameBatchExcel_vue__ = __webpack_require__(3966);
function injectStyle (ssrContext) {
  __webpack_require__(3960)
  __webpack_require__(3962)
  this["$style"] = __webpack_require__(3964)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-344d770e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceNameBatchExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_344d770e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceNameBatchExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3960:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3961);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("9513e5c6", content, true, {});

/***/ }),

/***/ 3961:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InvoiceNameBatchExcel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3962:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3963);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("ca0e709e", content, true, {});

/***/ }),

/***/ 3963:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "a[data-v-344d770e]{margin-right:10px;margin-bottom:10px}.re-el-upload-width-max[data-v-344d770e] .el-upload-dragger{height:200px}", "", {"version":3,"sources":["/workspace/src/views/finance-config/components/InvoiceNameBatchExcel.vue"],"names":[],"mappings":"AACA,mBAAmB,kBAAkB,kBAAkB,CACtD,AACD,4DAA4D,YAAY,CACvE","file":"InvoiceNameBatchExcel.vue","sourcesContent":["\na[data-v-344d770e]{margin-right:10px;margin-bottom:10px\n}\n.re-el-upload-width-max[data-v-344d770e] .el-upload-dragger{height:200px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3964:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3965);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("512f5c93", content, true, {});

/***/ }),

/***/ 3965:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InvoiceNameBatchExcel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"InvoiceNameBatchExcel",staticClass:"re-el-upload-width-max",attrs:{"drag":"","action":"","accept":".xlsx","on-remove":_vm.excelFileRemove,"on-change":_vm.excelFileChange,"before-upload":_vm.beforeFileUpload,"http-request":_vm.uploadRequest}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击选择文件")]),_vm._v(" "),_c('br'),_vm._v("\n    只能选择Excel文件\n  ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",staticStyle:{"margin-top":"0"},attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n    Excel 文件必须包含表头 "+_vm._s(_vm.xlsxReqText)),_c('br'),_vm._v("\n    字段值不得为空 "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.getDemo}},[_vm._v("下载 Demo\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/finance-config/invoice-name-management"}},[_vm._v("开票名称管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"选择Excel"}},[_c('invoice-name-batch-excel',{ref:"invoiceNameExcel",attrs:{"xlsxReqHeader":_vm.xlsxReqHeader()},on:{"getDemo":_vm.getDemo,"excelFileRemove":_vm.excelFileRemove,"change-file":function (_) { return this$1.file = _; },"change":function (_) { return this$1.form.data = _; }}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传进度"}},[_c('div',{staticStyle:{"margin-top":"8px"}},[(_vm.percentage < 100)?_c('el-progress',{attrs:{"percentage":_vm.percentage,"stroke-width":18,"color":"#666666"}}):_vm._e(),_vm._v(" "),(_vm.percentage === 100)?_c('el-progress',{attrs:{"percentage":100,"stroke-width":18,"status":"success"}}):_vm._e()],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"错误记录"}},[_vm._l((_vm.error_data),function(item){return _c('div',[_c('span',[_vm._v(_vm._s(item))])])})],2)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("开始上传\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3968:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3969);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("25db38de", content, true, {});

/***/ }),

/***/ 3969:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FinanceInvoiceNameForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3970:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3971);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1dcd4274", content, true, {});

/***/ }),

/***/ 3971:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FinanceInvoiceNameForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3972:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3973);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("770b693a", content, true, {});

/***/ }),

/***/ 3973:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FinanceInvoiceNameForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/finance-config/invoice-name-management"}},[_vm._v("财务中心设置列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.$route.meta.type === 'create' ? _vm.invoiceNameAddRule : _vm.invoiceNameEditRule,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[(_vm.$route.meta.type === 'edit')?[_c('el-form-item',{attrs:{"label":"开票名称","prop":"name"}},[_c('label',[_vm._v(_vm._s(_vm.form.name))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开票名称类别","prop":"type_name"}},[_c('label',[_vm._v(_vm._s(_vm.form.type_name))])])]:_vm._e(),_vm._v(" "),(_vm.$route.meta.type === 'create')?[_c('el-form-item',{attrs:{"label":"开票名称","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入开票名称"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开票名称类别","prop":"type_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","placeholder":"请输入开票名称类别名称进行搜索","query-request":function (_){ return _vm.invoiceNameTypeLists(Object.assign(_, {is_disabled: 0, need_full_match: 1})); },"find-request":_vm.getInvoiceNameType},model:{value:(_vm.form.type_id),callback:function ($$v) {_vm.$set(_vm.form, "type_id", $$v)},expression:"form.type_id"}})],1)]:_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"税率","prop":"tax_rate"}},[_c('el-input',{attrs:{"placeholder":"请填写税率"},model:{value:(_vm.form.tax_rate),callback:function ($$v) {_vm.$set(_vm.form, "tax_rate", $$v)},expression:"form.tax_rate"}},[_c('template',{slot:"append"},[_vm._v("%")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品编码","prop":"product_num"}},[_c('el-input',{attrs:{"placeholder":"请填写商品编码"},model:{value:(_vm.form.product_num),callback:function ($$v) {_vm.$set(_vm.form, "product_num", $$v)},expression:"form.product_num"}})],1)],2)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("保存\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/invoicing-name-batch-create.8cb27c0173f12a4a2067.js